import axios from "axios"
import { toast } from "react-toastify"

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    withCredentials: true,
})

api.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {
        if (error.response?.data.error === "feature not included in plan") {
            toast.error(
                "Faça um upgrade de plano para utilizar esta funcionalidade",
            )
            window.location.replace("/financeiro")
        }
        console.log(error.response?.data.error)
        return Promise.reject(error)
    },
)

export const openApi = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
})

export default api
